import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
// import Select from 'react-select'
import styled from 'styled-components'

import { withNamespaces } from 'react-i18next'

import { logout } from '../ducks/auth'
import { setActiveProperty } from '../ducks/properties'
import { setActiveProperty as setChartActiveProperty } from '../ducks/chart'
import { fetchInteractionsPreview } from '../ducks/interactionsPreview'
import { fetchContract } from '../ducks/contracts'
import { fetchNews } from '../ducks/news'

import DesktopNavbar from './DesktopNavbar'
import MobileNavbar from './MobileNavbar'

import { sendInfoToJivoChat } from '../ducks/tools'

const languages = {
  BG_BG: 'Bulgarian',
  MY: 'Burmese',
  CH: 'Chinese (Simplified)',
  ZH_HK: 'Chinese (Hong Kong)',
  ZH_TW: 'Chinese (Taiwan)',
  CZ_CZ: 'Czech',
  EN_EN: 'English',
  IN: 'Indonesian',
  JA: 'Japanese',
  KO: 'Korean',
  PL_PL: 'Polish',
  RU_RU: 'Russian',
  TH: 'Thai',
  VI: 'Vietnamese'
}

const NavbarWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #f1f2f3;
  background-color: #fff;
`

class NavbarContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      lang: 'DEF'
    }
  }
  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  componentDidMount() {
    const { i18n } = this.props
    this.setState({
      lang: i18n.language.toUpperCase()
    })
  }

  changeLanguage = (lang) => {
    const { i18n, fetchNews } = this.props
    i18n.changeLanguage(lang)
    this.setState({ lang })
    fetchNews()
  }

  render() {
    const { properties } = this.props
    const { authorized } = this.props.auth
    const { lang, isOpen } = this.state

    if (!authorized) {
      return null
    }

    return (
      <NavbarWrapper>
        {document.body.clientWidth >= 768 ? (
          <DesktopNavbar
            handlePropertyChange={this.handleChange}
            properties={properties}
            changeLanguage={this.changeLanguage}
            sendInfoToJivoChat={this.props.sendInfoToJivoChat}
            lang={lang}
            logout={() => this.props.logout(false)}
            toggle={this.toggle}
            isOpen={isOpen}
            propertyChangeHandlers={{
              handlePropertyMainChange: this.handlePropertyMainChange,
              handlePropertyInteractionsChange: this
                .handlePropertyInteractionsChange,
              handlePropertyContractsChange: this.handlePropertyContractsChange
            }}
            languages={languages}
          />
        ) : (
          <MobileNavbar
            handlePropertyChange={this.handleChange}
            properties={properties}
            toggle={this.toggle}
            isOpen={isOpen}
            lang={lang}
            changeLanguage={this.changeLanguage}
            logout={() => this.props.logout(false)}
            handlePropertyMainChange={this.handlePropertyMainChange}
            handlePropertyInteractionsChange={
              this.handlePropertyInteractionsChange
            }
            handlePropertyContractsChange={this.handlePropertyContractsChange}
            languages={languages}
          />
        )}
      </NavbarWrapper>
    )
  }

  handlePropertyMainChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value, false)
    this.props.setChartActiveProperty(value)
    this.props.fetchInteractionsPreview()
  }

  handlePropertyInteractionsChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value)
  }

  handlePropertyContractsChange = (e) => {
    const { value } = e.target

    this.props.setActiveProperty(value, false)
    this.props.fetchContract(value)
  }
}

export default compose(
  connect(
    ({ auth, properties }) => ({ auth, properties }),
    {
      logout,
      setActiveProperty,
      setChartActiveProperty,
      fetchInteractionsPreview,
      fetchContract,
      fetchNews,
      sendInfoToJivoChat
    },
    null,
    { pure: false }
  ),
  withNamespaces()
)(NavbarContainer)
